import "./Trusted.css";

function Trusted() {
  return (
    <section className="trusted">
      <div className="container">

        <p className="trusted-title">
          Trusted by Startups, Businesses & Organizations
        </p>

        <div className="row text-center g-4">

          <div className="col-6 col-md-3">
            <div className="trusted-card">
              <h2>100+</h2>
              <span>Projects Completed</span>
            </div>
          </div>

          <div className="col-6 col-md-3">
            <div className="trusted-card">
              <h2>80+</h2>
              <span>Happy Clients</span>
            </div>
          </div>

          <div className="col-6 col-md-3">
            <div className="trusted-card">
              <h2>5+</h2>
              <span>Years Experience</span>
            </div>
          </div>

          <div className="col-6 col-md-3">
            <div className="trusted-card">
              <h2>24×7</h2>
              <span>Support</span>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
}

export default Trusted;